export const isUserHasAdminRole = user => !!user.authorities.find(item => item.authority === 'ROLE_ADMIN')
